var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconImageLibrary = function SvgIconImageLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "icon-image-library_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-image-library_svg__a)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9.75a2.35 2.35 0 0 1 2.345 2.19l.005.16v9.8a2.35 2.35 0 0 1-2.19 2.345l-.16.005H7.1a2.35 2.35 0 0 1-2.345-2.19l-.005-.16V3.1A2.35 2.35 0 0 1 6.94.755L7.1.75h9.8zm-6.019 8.228-4.075 3.125v.797c0 .14.096.256.226.287l.068.007h9.8c.14 0 .256-.096.287-.226l.007-.068v-1.65l-1.314-1.015-1.438 1.08a1.03 1.03 0 0 1-1.16.05l-.106-.075-.082-.074-2.213-2.238zM16.9 2.806H7.1a.295.295 0 0 0-.287.226l-.007.068-.001 6.413 3.545-2.717c.34-.261.8-.28 1.167-.057l.106.074.084.076 2.218 2.243 1.347-1.01A1.025 1.025 0 0 1 16.292 8l.126.063.1.067.676.523V3.1a.295.295 0 0 0-.226-.287l-.068-.007zm-2.178 1.833a1.417 1.417 0 1 1 0 2.834 1.417 1.417 0 0 1 0-2.834z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.038 17.004c0 1.098.899 1.996 1.997 1.996h12.98a1 1 0 0 0 0-1.996H3.733a.7.7 0 0 1-.7-.702l-.036-9.279A.999.999 0 1 0 1 7.021l.038 9.983z"
  }))));
};

export default SvgIconImageLibrary;